import {useQuery} from '@tanstack/react-query';

import {useExperimentsStore} from 'apps/experiments/src/store';
import {propertiesQueryKey} from 'apps/experiments/src/react-query';
import {eventPropertyValuesClient} from 'common/report/queries/query-api/event-property-values-client';
import {
  EXPERIMENT_NAME_PROPERTY,
  EXPERIMENT_STARTED_EVENT,
} from 'apps/experiment-reporting/src/experiment-reporting-app/constants';
import {EXPERIMENT_PROPERTY_PREFIX} from 'common/report/constants';

import {useExperimentPageContext} from '../context';

export const useExperimentOptions = () => {
  const {projectId, workspaceId} = useExperimentPageContext();

  const draftExperiment = useExperimentsStore((state) => state.draftExperiment);

  const {data: experimentNames = []} = useQuery({
    queryKey: propertiesQueryKey({
      projectId: projectId!,
      workspaceId: workspaceId!,
    }),
    queryFn: () =>
      eventPropertyValuesClient.query({
        eventName: EXPERIMENT_STARTED_EVENT,
        propertyName: EXPERIMENT_NAME_PROPERTY,
        projectId: projectId!,
        workspaceId: workspaceId!,
      }) as Promise<string[]>,
  });

  const experimentName = draftExperiment?.settings?.exposureEventSettings?.experimentName;

  const {data: variantNames = []} = useQuery({
    queryKey: propertiesQueryKey({
      projectId: projectId!,
      workspaceId: workspaceId!,
      experimentName,
    }),
    enabled: !!experimentName,
    queryFn: () =>
      eventPropertyValuesClient.query({
        propertyName: `${EXPERIMENT_PROPERTY_PREFIX}${experimentName}`,
        projectId: projectId!,
        workspaceId: workspaceId!,
      }) as Promise<string[]>,
  });

  return {
    experimentNames,
    variantNames,
  };
};
